import { createSlice } from '@reduxjs/toolkit';

const updateUserEnrolledDeviceDetailsSlice = createSlice({
  name: 'updateUserEnrolledDevice',
  initialState: {
    success: false,
    loading: false,
    enrolledDevice: null,
    error: null,
  },
  reducers: {
    updateEnrolledDeviceRequest(state) {
      state.loading = true;
      state.error = null;
    },
    updateEnrolledDeviceSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.enrolledDevice = action.payload;
    },
    updateEnrolledDeviceFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
      state.success = false;
    },
    updateEnrolledDeviceReset(state) {
      return {...state, loading: false, enrolledDevice: null, success:  false, error: null};
    }
  },
});

export const {
  updateEnrolledDeviceRequest,
  updateEnrolledDeviceSuccess,
  updateEnrolledDeviceFailure,
  updateEnrolledDeviceReset
} = updateUserEnrolledDeviceDetailsSlice.actions;

export default updateUserEnrolledDeviceDetailsSlice.reducer;
